import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
const TutorLayout = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('lmsuser'));
    useEffect(() => {        
        if(user?.is_tutor !== 1)
        {
            navigate('/dashboard/home');
        }
    }, []);
    return (
        <>
        <Outlet />
        </>
    );
}

export default TutorLayout;